(function () {
  if (window.__mpnPrep) return; window.__mpnPrep = true;
  function place() {
    var tpl = document.getElementById('mpn-prep-tpl');
    if (!tpl) return;
    document.querySelectorAll('.mineral-delivery-content').forEach(function (c) {
      /* MOBILE : bouton « Fermer » colle en bas de l'ecran, pour quitter sans remonter tout le panneau */
      var dr = c.closest('.mineral-delivery-drawer');
      if (dr && !dr.querySelector('.mpn-close-bar')) {
        var cl = dr.querySelector('.mineral-delivery-close');
        var bar = document.createElement('div'); bar.className = 'mpn-close-bar';
        var bt = document.createElement('button'); bt.type = 'button';
        bt.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M3 3l10 10M13 3 3 13" stroke="currentColor" stroke-width="1.8" fill="none"/></svg><span>' + ((cl && cl.getAttribute('aria-label')) || 'Fermer') + '</span>';
        bt.addEventListener('click', function (e) { e.preventDefault(); if (cl) cl.click(); });
        bar.appendChild(bt); dr.appendChild(bar);
      }
      if (c.querySelector('.mpn-prep')) return;
      var steps = c.querySelectorAll('.mineral-delivery-step');
      if (!steps.length) return;
      var lastStep = steps[steps.length - 1];
      var after = document.getElementById('mpn-after-tpl');
      if (after) lastStep.parentNode.insertBefore(after.content.cloneNode(true), lastStep.nextSibling);
      steps[0].parentNode.insertBefore(tpl.content.cloneNode(true), steps[0]);
      /* etapes renumerotees : 01 preparation, 02-04 livraison, 05 apres la livraison ; photo sous le titre des etapes 02-04 */
      c.querySelectorAll('.mineral-delivery-step').forEach(function (st, i) {
        var n = st.querySelector('.mineral-step-number');
        if (n) n.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        var pt = document.getElementById('mpn-ph-tpl-' + (i + 1));
        var h = st.querySelector('h3');
        if (pt && h && pt.content.childElementCount && !st.querySelector('.mpn-step-ph')) h.insertAdjacentElement('afterend', pt.content.firstElementChild.cloneNode(true));
      });
      /* « Bon a savoir » (livraison sur palette : acces poids lourd, zone de depose) -> dans l'etape 03 « Votre commande arrive a domicile » */
      var info = c.querySelector('.mineral-delivery-info');
      var st3 = c.querySelectorAll('.mineral-delivery-step')[2];
      if (info && st3 && st3.lastElementChild) { info.classList.add('mpn-info-in'); st3.lastElementChild.appendChild(info); }
    });
  }
  /* Carrousel de la galerie de l'etape 01 : fleches + compteur, le doigt fonctionne toujours sur mobile */
  var ARROW = function (d) { return '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="' + (d < 0 ? 'M10 3 5 8l5 5' : 'm6 3 5 5-5 5') + '" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>'; };
  function carousel() {
    document.querySelectorAll('.mineral-delivery-content .mpn-prep__gal.is-multi:not([data-car])').forEach(function (g) {
      if (getComputedStyle(g).display === 'none') return;
      g.setAttribute('data-car', '1');
      var items = g.querySelectorAll('.mpn-prep__ph'); var n = items.length; if (n < 2) return;
      var wrap = document.createElement('div'); wrap.className = 'mpn-car';
      g.parentNode.insertBefore(wrap, g); wrap.appendChild(g);
      var lang = (document.documentElement.lang || 'fr').slice(0, 2);
      var L = { fr: ['Photo précédente', 'Photo suivante'], en: ['Previous photo', 'Next photo'], de: ['Vorheriges Foto', 'Nächstes Foto'] }[lang] || ['Photo précédente', 'Photo suivante'];
      var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'mpn-car__btn mpn-car__btn--prev'; prev.setAttribute('aria-label', L[0]); prev.innerHTML = ARROW(-1);
      var next = document.createElement('button'); next.type = 'button'; next.className = 'mpn-car__btn mpn-car__btn--next'; next.setAttribute('aria-label', L[1]); next.innerHTML = ARROW(1);
      var count = document.createElement('span'); count.className = 'mpn-car__count';
      wrap.appendChild(prev); wrap.appendChild(next); wrap.appendChild(count);
      function idx() { return Math.round(g.scrollLeft / (g.clientWidth || 1)); }
      /* lignes de l'etape reliees aux photos (data-k) : toucher une ligne = voir sa photo */
      var step = wrap.closest('.mpn-prep');
      var lis = step ? step.querySelectorAll('.mpn-prep__list li[data-k]') : [];
      function slideOf(k) { for (var j = 0; j < n; j++) { if (items[j].getAttribute('data-k') === k) return j; } return -1; }
      function keysOf(li) { return (li.getAttribute('data-k') || '').split(' '); }
      Array.prototype.forEach.call(lis, function (li) {
        var j = -1; keysOf(li).some(function (k) { j = slideOf(k); return j >= 0; });
        if (j < 0) return;
        li.classList.add('is-link'); li.tabIndex = 0; li.setAttribute('role', 'button');
        function go(e) { e.preventDefault(); e.stopPropagation(); g.scrollTo({ left: j * g.clientWidth }); }
        li.addEventListener('click', go);
        li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
      });
      function upd() {
        var i = idx(); prev.disabled = i <= 0; next.disabled = i >= n - 1; count.textContent = (i + 1) + ' / ' + n;
        var k = items[i] ? items[i].getAttribute('data-k') : '';
        Array.prototype.forEach.call(lis, function (li) { var on = keysOf(li).indexOf(k) >= 0 && li.classList.contains('is-link'); li.classList.toggle('is-on', on); li.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      }
      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); g.scrollTo({ left: (idx() - 1) * g.clientWidth }); });
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); g.scrollTo({ left: (idx() + 1) * g.clientWidth }); });
      g.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }
  /* Photos du panneau prechargees des que la ligne « Expedition securisee » (ou la carte livraison) est visible,
     pour qu'elles soient deja la a l'ouverture (sinon : chargement seulement au clic, lent sur mobile). */
  var warmed = false;
  /* Prechargement UNIQUEMENT si le panneau peut s'ouvrir sur cette fiche : ligne palette cliquable, ou carte livraison
     visible. Commande en colis (ligne non cliquable, demande d'Ed) : aucune photo du panneau chargee, page plus legere. */
  function wanted() {
    var b = document.querySelector('.mineral-ship-est');
    if (b && !b.hidden && b.querySelector('.mse-safe')) return !!b.querySelector('[data-open-delivery]');
    var t = document.querySelector('.mineral-delivery-trigger');
    return !!(t && t.offsetHeight);
  }
  function warm() {
    if (warmed || !wanted()) return; warmed = true;
    document.querySelectorAll('.mineral-delivery-content img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }
  function watch() {
    if (warmed) return;
    var t = document.querySelector('.mineral-ship-est') || document.querySelector('.mineral-delivery-wrap');
    if (!t) return;
    if (!('IntersectionObserver' in window)) { warm(); return; }
    if (t.__mpnWatch) return; t.__mpnWatch = true;
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); setTimeout(warm, 300); } });
    io.observe(t);
  }
  document.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('.mse-safe, .mse-heavy, .mineral-delivery-trigger')) warm(); }, true);
  /* Typo francaise : espace insecable avant ? : ! ; (et apres «) dans le panneau, pour ne jamais laisser
     un « ? » ou un « : » seul en debut de ligne (demande d'Ed). Francais uniquement. */
  function nbsp() {
    if ((document.documentElement.lang || 'fr').slice(0, 2) !== 'fr') return;
    document.querySelectorAll('.mineral-delivery-drawer').forEach(function (d) {
      var w = document.createTreeWalker(d, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var NB = String.fromCharCode(160); /* insecable ecrit en code : le caractere lui-meme est perdu a l'envoi vers Shopify */
        var v = n.nodeValue, r = v.replace(/ +([?:!;»])/g, NB + '$1').replace(/« +/g, '«' + NB);
        if (r !== v) n.nodeValue = r;
      }
    });
  }
  function all() { place(); carousel(); watch(); nbsp(); }
  /* prechargement des photos du panneau ~1 s apres l'affichage de la page, sans attendre le chargement complet
     (sur mobile, l'evenement « load » arrive tard) ; priorite basse pour ne pas ralentir les photos produit */
  function early() { all(); setTimeout(function () { document.querySelectorAll('.mineral-delivery-content img').forEach(function (i) { try { i.fetchPriority = 'low'; } catch (e) {} }); warm(); }, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', early); else early();
  window.addEventListener('load', function () { all(); setTimeout(warm, 800); });
  setTimeout(watch, 1500); setTimeout(warm, 5000);
  /* quantite modifiee (colis -> palette) : prechargement des que la ligne palette apparait */
  var wi = setInterval(function () { if (warmed) { clearInterval(wi); return; } warm(); }, 2000);
  document.addEventListener('click', function () { setTimeout(all, 0); setTimeout(carousel, 400); }, true);
})();
/* Bloc « Un doute sur la quantite ou le rendu ? » (bloc Liquid personnalise du modele produit) : meme espace
   au-dessus et au-dessous (16 px), quel que soit l'espacement des blocs voisins (demande d'Ed). */
(function () {
  var GAP = 16;
  function vis(el) { return el && el.offsetHeight > 0 && getComputedStyle(el).display !== 'none'; }
  /* voisin pris en compte = bloc reellement place dans le flux (pas un panneau fixe / en surimpression) */
  function inFlow(el) { var ps = getComputedStyle(el).position; return vis(el) && ps !== 'fixed' && ps !== 'absolute'; }
  function eq() {
    var a = [].filter.call(document.querySelectorAll('.mineral-phone-block'), vis)[0];
    if (!a) return;
    /* On ne touche JAMAIS a l'interieur du bloc (padding) : seulement l'espace blanc au-dessus et au-dessous. */
    var w = a, p = a.parentElement;
    if (p && !p.classList.contains('product__info-container') &&
        [].filter.call(p.children, vis).length === 1) w = p;
    /* Positions de MISE EN PAGE (offsetTop), pas positions a l'ecran : les blocs du dessous glissent a
       l'apparition (animation au defilement). Mesures a l'ecran = faussees par l'animation -> bloc colle (Ed). */
    function top(el) { var y = 0; while (el) { y += el.offsetTop; el = el.offsetParent; } return y; }
    function bot(el) { return top(el) + el.offsetHeight; }
    function set(el, prop, v) { el.style.setProperty(prop, Math.round(v) + 'px', 'important'); }
    /* blocs vides entre deux (applis sans contenu...) : leurs marges s'ajouteraient a l'espace */
    function flat(el) { if (!/^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(el.tagName)) { set(el, 'margin-top', 0); set(el, 'margin-bottom', 0); } }
    var prev = w.previousElementSibling; while (prev && !inFlow(prev)) { if (!vis(prev)) flat(prev); prev = prev.previousElementSibling; }
    var next = w.nextElementSibling; while (next && !inFlow(next)) next = next.nextElementSibling;
    /* Ajuste une marge du bloc jusqu'a obtenir exactement GAP, en partant de sa valeur actuelle (pas de remise a zero :
       aucun saut a l'ecran) ; tient compte des marges negatives des blocs vides voisins (ex. bloc livraison -20 px). */
    function tune(prop, gap) {
      for (var i = 0; i < 4; i++) {
        var d = GAP - gap(); if (Math.abs(d) < 1) return;
        set(w, prop, (parseFloat(getComputedStyle(w)[prop === 'margin-top' ? 'marginTop' : 'marginBottom']) || 0) + d);
      }
    }
    if (prev) { set(prev, 'margin-bottom', 0); tune('margin-top', function () { return top(w) - bot(prev); }); }
    /* Au-dessous : le bandeau « Entreprise familiale / 7 magasins / Paiement » (ou, a defaut, le bloc suivant) */
    var below = [].filter.call(document.querySelectorAll('.product__reassurances'), function (r) { return vis(r) && top(r) >= top(w); })[0] || next;
    if (below) { if (parseFloat(getComputedStyle(below).marginTop)) set(below, 'margin-top', 0); tune('margin-bottom', function () { return top(below) - bot(w); }); }
  }
  /* Recalcule au chargement et si la largeur change vraiment (pas sur la barre d'adresse mobile qui se replie). */
  var lastW = window.innerWidth;
  function safe() { eq(); }
  var t; function later() { clearTimeout(t); t = setTimeout(safe, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  window.addEventListener('load', later);
  window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; clearTimeout(t); t = setTimeout(eq, 150); } });
  [300, 800, 1500, 3000].forEach(function (ms) { setTimeout(safe, ms); });
  setInterval(eq, 1000); /* mesure de mise en page : rien ne bouge si c'est deja bon ; rattrape les blocs qui changent apres coup */
})();
